import { useSelector } from "react-redux";
import { authUser } from "../store/slice/authSlice";

export function useIsCompanyAdmin() {
  const user = useSelector(authUser);
  return Boolean(
    user?.is_superuser || user?.groups?.some(group => Number(group.id) === 1),
  );
}
